import { caseDefaultDetails } from '../../App/App.config';
import { router } from '../../services'
import pushGTMEvent from './../../util/helper/pushGTMEvent';
import log from 'loglevel';

const changeCM = async (
  userSession,
  newCMDetails,
  currentCMDetails,
  credentials,
) => {
  log.debug('userSession : ', userSession)
  log.debug('newCmDetails : ', newCMDetails)

  const payload = {
    requester: {
      country: 'US',
      email: userSession.email,
      firstName: userSession.first,
      lastName: userSession.last,
    },
    contractManager: {
      country: 'US',
      firstName: newCMDetails.firstName,
      lastName: newCMDetails.lastName,
      email: newCMDetails.email,
    },
    authEmail: currentCMDetails.authEmail,
    serviceContract: currentCMDetails.contractNumber,
    case: {
      ...caseDefaultDetails,
    },
  }

  try {
    const cmResponse = await router('CM', payload, credentials)
    log.debug('RESPONSE FROM ETE SERVICE ::: ', cmResponse)
    return cmResponse
  } catch (err) {
    log.debug(err)
    return err
  }
}

const asynCMCall = async(dispatch, userSession, newCmDetails, currentCMDetails, credentials) => {
  log.debug('Page 4 : User clicks on Submit and show spinner page ');
  dispatch({ type: 'GO_TO_SPIN_PAGE' });
  const response = await changeCM(userSession, newCmDetails, currentCMDetails, credentials);
  if (response.status === 200) {
    // SUCCESS
    pushGTMEvent('Success');
    log.debug('API response status 200 and value : ', response);
    //dispatch({ type: 'UPDATE_SUCCESS' });
    dispatch({ type: 'GO_TO_SUCCESS_PAGE', payload: 'success' });
  } else if (response.status === 400) {
    // ERROR
    log.debug('API response status 400 and value  : ', response);
    const errorString = 'Error/'+ response.errors[0].code;
    pushGTMEvent(errorString);
    response.errors.forEach((error) => {
      let errorDesc;
      let errorMessage;
      switch (error.code) {
        case 'CM-04':
          errorDesc = `Expired Subscription\nAPIGEE Code: ${error.code}\nAPIGEE Details: ${error.detail}`;
          errorMessage = 'Expired Subscription';
          dispatch({
            type: 'UPDATE_CM_ERROR',
            payload: {
              errorDesc,
              errorMessage
              }
            });
          log.debug('CM:04 Expired Subscription Error page landing');
          dispatch({ type: 'EXPAND_FOOTER_ON_ERROR'});
          return dispatch({ type: 'GO_TO_ERROR_PAGE', payload: 'expiredSubscription' });
        case 'CM-05':
          errorDesc = `Auto-Renew Subscription\nAPIGEE Code: ${error.code}\nAPIGEE Details: ${error.detail}`;
          errorMessage = 'Auto-Renew Subscription';
          dispatch({
            type: 'UPDATE_CM_ERROR',
            payload: {
              errorDesc,
              errorMessage
              }
            });
          log.debug('CM:05 Auto-renew subscription Error page landing');
          dispatch({ type: 'EXPAND_FOOTER_ON_ERROR'});
          return dispatch({ type: 'GO_TO_ERROR_PAGE', payload: 'autoRenewCMError' });
        default:
          errorDesc = `Generic Error\nAPIGEE Code: ${error.code}\nAPIGEE Details: ${error.detail}`;
          errorMessage = 'Generic Error';
          // submitAgain true for cmCall.
          dispatch({
            type: 'HANDLE_SUBMIT_AGAIN', 
            payload: {
              type: 'cmCall',
              value: true
            }
          });
          dispatch({
            type: 'UPDATE_CM_ERROR',
            payload: {
              errorDesc,
              errorMessage
              }
            });
          log.debug('General CM ERROR page landing');
          return dispatch({ type: 'GO_TO_ERROR_PAGE', payload: 'generalError' });
      }
    });
  } else {
    // UNKNOWN
    log.debug('General CM ERROR page landing, status code : ', response.status);
    // submitAgain true for cmCall.
    dispatch({
      type: 'HANDLE_SUBMIT_AGAIN', 
      payload: {
        type: 'cmCall',
        value: true
      }
    });
    dispatch({ type: 'GO_TO_ERROR_PAGE', payload: 'generalError' });
  }
}

export default asynCMCall;
